const { Pagination, Mousewheel } = require("swiper/modules");
import { addToCart } from './services/cart-api';

document.addEventListener('DOMContentLoaded', function () {
    const isMobile = window.innerWidth <= 768;
    if ( isMobile ) {
        const atcFixedButton = document.querySelector('.product-page-template .fixed-atc');
        const atcRegularButton = document.querySelector('.template-product .product-form__item.product-form__item--submit');

        const manageATCFixedButtonVisibility = (atcFixedButton, atcRegularButton) => {
            const atcRegularButtonRect = atcRegularButton && atcRegularButton.getBoundingClientRect();
            const isATCRegularButtonVisible = atcRegularButtonRect.top > 0 && atcRegularButtonRect.top < 600;
            atcFixedButton.style.display = isATCRegularButtonVisible ? 'none' : '';
        };

        if (atcFixedButton && atcRegularButton) {
          manageATCFixedButtonVisibility(atcFixedButton, atcRegularButton);
          window.onscroll = () => manageATCFixedButtonVisibility(atcFixedButton, atcRegularButton);
        }
    }

  // PDP redesign
  initPDPRedesign();
});

const swiperRelatedProducts = new Swiper('.related-products__carousel',{
  slidesPerView: 4,
  loop: true,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 4,
    }
  }
})

// PDP redesign
function initPDPRedesign () {

  const isMobile = window.innerWidth <= 768;

    const descriptionsIconPlus = document.querySelector('.main-product-container .description-product-container .description-product-container__icons .description-plus');
    const descriptionsIconMinus = document.querySelector('.main-product-container .description-product-container .description-product-container__icons .description-minus');
    const atcStyledButtons = document.querySelectorAll('.main-product-container .styled-with-container__item--button');
    const colorSwatchesStyled = document.querySelectorAll('.main-product-container .styled-with-container label.ColorSwatch');
    const productsStyledIt = document.querySelectorAll('.main-product-container .styled-with-container .styled-with-container__item');
    const productColorNameLabel = document.querySelector('.main-product-container .product-form__item.color .option-name');
    const productColorsContainer = document.querySelector('.main-product-container .product-form__item.color .single-option-radio.color');
    const productSizesContainer = document.querySelector('.main-product-container .product-form__item.size .product-size-options .sizes-container');
    const ATCButton = document.querySelector('.main-product-container .product-form__cart-submit.main-atc-button');
    const mayLikeSizesButtons = document.querySelectorAll('.may-also-like-products-container .hover-buttons');

    // product thumbnails swiper
    let productThumbnailsSwiper = new Swiper('.main-product-container__image--thumbs-swiper', {
      slidesPerView: "auto",
      spaceBetween: 8,
      direction: "horizontal",
      loop: false,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          direction: "vertical",
          mousewheel: {
            forceToAxis: true,
          },
        }
      }
    });
    goToActiveThumbnailSlide(productThumbnailsSwiper);


    // handle color option name to change the color label and the corresponding sizes
    if (productColorNameLabel && productColorsContainer) {
      handleColorOptionName(productColorNameLabel, productColorsContainer, productSizesContainer, productThumbnailsSwiper, ATCButton);
    }

    // set sizes using the default color
    if (productColorsContainer && productSizesContainer) {
      setSizesByDefaultColor(productColorsContainer, productSizesContainer);
    }

    // set variant id on ATC button
    if (productSizesContainer && ATCButton) {
      handleSizeOptions(productSizesContainer, ATCButton);
    }

    // perform ATC action
    if (ATCButton) {
      handleProductATC(ATCButton);
    }

    // description icon
    if (descriptionsIconPlus && descriptionsIconMinus) {
      handleDescriptionIcon(descriptionsIconPlus, descriptionsIconMinus);
      handleAllDescriptionTabs();
    }

    // styled with main slider
    let styledSwiper = new Swiper('.styled-with-container-swiper', {
      slidesPerView: 1,
      loop: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.swiper-button-next-styled',
        prevEl: '.swiper-button-prev-styled',
      },
    });

    // styled-it color swatches slider
    let swatchesSwiper = new Swiper('.swiper-color-swatches', {
      slidesPerView: 9,
      slidesPerGroup: 9,
      spaceBetween: 10,
      slidesOffsetBefore: 2,
      // slidesOffsetAfter: 50,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.swiper-button-next-color-swatches',
        prevEl: '.swiper-button-prev-color-swatches',
      },
    });

    // may-also-like slider
    let relatedProductsSwiper = new Swiper('.swiper-may-also-like-products', {
      slidesPerView: 2,
      slidesPerGroup: 2,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        dragSize: 50,
        el: '.swiper-scrollbar',
      },
      breakpoints: {
        426: {
          slidesPerGroup: 1,
        },
        950: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        }
      }
    });

    // handle sizes container on mobile you may also like section
    if (isMobile && mayLikeSizesButtons.length) {
      handleMayLikeSizesButtons(mayLikeSizesButtons);
    }

    // close the sizes container on add to card
    document.addEventListener('pdm-cart-toggle', async event => {
      const isCartOpenTriggered = event.detail.isCartOpen;
      if (isCartOpenTriggered) {
        const sizesContainer = document.querySelector('.sizes-container-fixed.mobile-only');
        if (sizesContainer) {
          sizesContainer.classList.add('product-hidden');
        }
      }
    });

    // styled with ATC
    if (atcStyledButtons.length) {
      atcStyledButtons.forEach(button => {
        button.addEventListener('click', e => handleAtcStyledButtonClick(e, button));
      });
    }

    // swatches events styled with section
    if (colorSwatchesStyled.length) {
      colorSwatchesStyled.forEach(swatch => {
        swatch.addEventListener('click', e => handleSwatchClick(e, swatch));
      });
    }

    // set color name when page loads on styled-it-with section
    if (productsStyledIt.length) {
      productsStyledIt.forEach(product => {
        const firstColorSwatch = product.querySelector('.colors-container .ColorSwatch:first-child');
        const colorLabelContainer = product.querySelector('.product-color-swatches__label-container');
        const colorNameContainer = product.querySelector('.product-color-swatches__selected-color-label');

        if (firstColorSwatch) {
          const selectedColorName = firstColorSwatch.getAttribute('data-tooltip');
          if (colorNameContainer && selectedColorName) {
            colorNameContainer.textContent = selectedColorName;
          }
        } else {
          if (colorLabelContainer) {
            colorLabelContainer.style.display = 'none';
          }
        }
      });
    }

    // frequently bought together section
    handleFrequentlyBoughtTogetherSection();

    // handle click outside of the sizes container
    document.addEventListener('click', e => {
      const sizesContainer = document.querySelector('.sizes-container-fixed.mobile-only');
      const body = document.querySelector('body');
      if (sizesContainer && !sizesContainer.contains(e.target)) {
        sizesContainer.classList.add('product-hidden');
        body.classList.remove('overlay');
      }
    });

}

/**
 * Hides size swatch labels that don't match the default (first) color.
 * Retrieves the default color from the first .content-variant-color element in productColorsContainer,
 * then iterates through each .size-swatch-label in productSizesContainer to add a hidden class when mismatched.
 */
function setSizesByDefaultColor (productColorsContainer, productSizesContainer) {
  const firstColorItem = productColorsContainer.querySelector('.content-variant-color:first-child');
  const colorNameDefault = firstColorItem && firstColorItem.getAttribute('data-color');
  const sizeItems = productSizesContainer.querySelectorAll('.size-swatch-label');

  if (sizeItems.length) {
    sizeItems.forEach(sizeItem => {
      const sizeItemColor = sizeItem.getAttribute('data-color');

      if (colorNameDefault !== sizeItemColor) {
        sizeItem.classList.add('size-option-hidden');
      }
    });
  }
}

/**
 * Updates the selected size option and sets the matching variant ID on each ATC button.
 * Ensures only one size option is marked as selected at a time.
 * Propagates the variant ID from the clicked size option to the ATC buttons.
 */
function handleSizeOptions(productSizesContainer, ATCButton) {
  const sizeOptions = productSizesContainer.querySelectorAll('.size-swatch-label');

  if (sizeOptions.length) {
    sizeOptions.forEach(sizeOption => {
      sizeOption.addEventListener('click', e => {
        e.preventDefault();

        // handle selected class over the size options
        sizeOptions.forEach(size => size.classList.remove('selected'));
        sizeOption.classList.add('selected');

        const variantRadio = sizeOption.querySelector('.size-swatch-radio');
        const variantID = variantRadio?.getAttribute('data-variant-id');
        const isPreOrder = variantRadio?.getAttribute('data-pre-order') === "true";

        if (variantID && ATCButton) {
          ATCButton.setAttribute('data-variant-id', variantID);

          // activate button
          ATCButton.removeAttribute('disabled');

          // swap content pre-order o normal
          if (isPreOrder) {
            ATCButton.textContent = ATCButton.getAttribute('data-atc-label-pre-order');
          } else {
            ATCButton.textContent = ATCButton.getAttribute('data-atc-label');
          }
        }
      });
    });
  }
}

/**
 * Attaches a click event listener to each Add-to-Cart button.
 * When clicked, it prevents default behavior and stops propagation, then retrieves
 * the variant ID from the button's data attribute and adds that variant to the cart.
 * On a successful add-to-cart response, the mini-cart is refreshed.
 *
 * @param ATCButton - An Add-to-Cart button.
 */
function handleProductATC(ATCButton) {
  if (ATCButton) {
    ATCButton.addEventListener('click', async e =>  {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const variantID = ATCButton.getAttribute('data-variant-id');
      const addToCartResponse = await addToCart(variantID, 1);

      if (addToCartResponse.status) {
        theme.miniCart.generateCart();
        theme.miniCart.updateElements();
      }
    });
  }
}

/**
 * Updates the color name label and filters size options based on the selected color.
 * Sets the default label from the first color and updates on click.
 * Hides sizes that don't match the selected color.
 */
function handleColorOptionName(productColorNameLabel, productColorsContainer, productSizesContainer, productThumbnailsSwiper, ATCButton) {
  const colorItems = productColorsContainer.querySelectorAll('.content-variant-color.content-color');
  const sizeItems = productSizesContainer && productSizesContainer.querySelectorAll('.size-swatch-label');

  if (colorItems.length) {
    colorItems.forEach((colorItem, index) => {
      if (index === 0) {
        const colorName = colorItem.querySelector('.customize_color').getAttribute('data-original-title');
        productColorNameLabel.textContent = colorName;
      }

      // change the color name on click
      colorItem.addEventListener('click', ()=>{
        const colorName = colorItem.querySelector('.customize_color').getAttribute('data-original-title');
        const selectedColorForSize = colorItem.getAttribute('data-color');

        // set the new name
        if (colorName) {
          productColorNameLabel.textContent = colorName;
        }

        // change the sizes
        if (sizeItems && sizeItems.length) {
          if (selectedColorForSize) {
            sizeItems.forEach(sizeItem => sizeItem.classList.remove('size-option-hidden'));

            sizeItems.forEach(sizeItem => {
              const sizeItemColor = sizeItem.getAttribute('data-color');

              if (sizeItemColor && selectedColorForSize !== sizeItemColor) {
                sizeItem.classList.add('size-option-hidden');
              }
            });
          }
        } else {
          const variantID = colorItem?.getAttribute('data-variant-id');
          if (variantID && ATCButton) {
            ATCButton.setAttribute('data-variant-id', variantID);
          }
        }

        // move thumbnails slider to the active one
        setTimeout(()=>{
          goToActiveThumbnailSlide(productThumbnailsSwiper);
        },500);

        // disable ATC when changing through colors
        if (ATCButton) {
          ATCButton.setAttribute('disabled', 'disabled');
          ATCButton.textContent = ATCButton.getAttribute('data-atc-label-disabled');
        }
      });
    });
  }
}

/**
 * Toggles the product description content visibility and swaps the plus/minus icons.
 * On click, it toggles the "product-hidden" class on the description and updates icons based on the data-action attribute.
 */
function handleDescriptionIcon (descriptionsIconPlus, descriptionsIconMinus) {
  const descriptionsIcons = [descriptionsIconPlus, descriptionsIconMinus];

  if (descriptionsIcons.length) {
    descriptionsIcons.forEach(icon => {

      icon.addEventListener('click', () => {
        const descriptionContent = icon.closest('.description-product-container').querySelector('.description-product-container__content');
        descriptionContent && descriptionContent.classList.toggle('product-hidden');

        if (icon.dataset.action === "open") {
          descriptionsIconPlus.classList.add('product-hidden');
          descriptionsIconMinus.classList.remove('product-hidden');
        } else {
          descriptionsIconPlus.classList.remove('product-hidden');
          descriptionsIconMinus.classList.add('product-hidden');
        }
      });
    });
  }
}
function handleAllDescriptionTabs() {
  const containers = document.querySelectorAll('.description-product-container');

  containers.forEach(container => {
    const icons = container.querySelectorAll('.description-product-container__icons svg');
    const content = container.querySelector('.description-product-container__content');

    if (!icons.length || !content) return;

    const plusIcon = icons[0];
    const minusIcon = icons[1];

    plusIcon.addEventListener('click', () => {
      content.classList.remove('product-hidden');
      plusIcon.classList.add('product-hidden');
      minusIcon.classList.remove('product-hidden');
    });

    minusIcon.addEventListener('click', () => {
      content.classList.add('product-hidden');
      plusIcon.classList.remove('product-hidden');
      minusIcon.classList.add('product-hidden');
    });
  });
}



/**
 * Handles a styled ATC button click: prevents default action, retrieves the selected variant ID, adds it to the cart, and updates the miniCart on success.
 */
async function handleAtcStyledButtonClick(e, atcButton) {
  e.preventDefault();

  const selectedVariantId = atcButton.getAttribute('data-variant-id');

  if (selectedVariantId) {
    let addToCartResponse = await addToCart(selectedVariantId, 1);

    if (addToCartResponse.status) {
      theme.miniCart.generateCart();
      theme.miniCart.updateElements();
    }
  }
}

/**
 * Handles swatch clicks: prevents default action, toggles the "selected" state,
 * updates the ATC button's variant ID, and sets the displayed color name.
 */
function handleSwatchClick (e, swatch) {
  e.preventDefault();

  const productContainer = swatch.closest('.styled-with-container__item');
  const productColorSwatches = productContainer.querySelectorAll('.ColorSwatch');
  const swatchRadio = swatch.querySelector('.ColorSwatch__Radio');
  const atcButton = productContainer.querySelector('.styled-with-container__item--button');
  const colorNameContainer = productContainer.querySelector('.product-color-swatches__selected-color-label');
  const variantImageUrl = swatch.getAttribute('data-variant-image-url');
  const mainImageSection = productContainer.querySelector('.styled-with-container__item--image-img');

  // handle selected class
  if (productColorSwatches.length) {
    productColorSwatches.forEach(swatch => {
      swatch.classList.remove('selected');
    });
  }
  swatch.classList.add('selected');

  // set variant ID
  const selectedVariantId = swatch.getAttribute('data-variant-id');
  if (atcButton && selectedVariantId) {
    atcButton.setAttribute('data-variant-id', selectedVariantId);
  }

  // set color name
  const selectedColorName = swatch.getAttribute('data-tooltip');
  if (colorNameContainer && selectedColorName) {
    colorNameContainer.textContent = selectedColorName;
  }

  // set variant image
  if (mainImageSection && variantImageUrl) {
    mainImageSection.setAttribute('src', variantImageUrl);
  }
}

/**
 * Manages the Frequently Bought Together section by toggling product images and updating total price
 * based on selected variant checkboxes, adapting the UI for mobile/desktop, and handling add-to-cart actions.
 */
function handleFrequentlyBoughtTogetherSection() {
  const fbtTotalEls = document.querySelectorAll('.freq-bought-together-wrapper .fbt__total');
  const fbtImgContainers = Array.from(document.querySelectorAll('.freq-bought-together-wrapper .fbt__img-container'));
  const fbtAtcButtons = document.querySelectorAll('.freq-bought-together-wrapper .fbt__atc, .fbt__atc-mobile');
  const plusTwo = document.getElementById('fbt-plus-two');
  const fbtDesktopOnly = document.querySelectorAll('.freq-bought-together-wrapper .desktop-only');
  const fbtMobileOnly = document.querySelectorAll('.freq-bought-together-wrapper .mobile-only');
  const isMobile = window.innerWidth <= 768;
  const checkboxes = document.querySelectorAll(`.freq-bought-together-wrapper input[type=checkbox]${isMobile ? '.mobile-only' : '.desktop-only'}`);

  if (isMobile) {
    if (fbtDesktopOnly.length) {
      fbtDesktopOnly.forEach(element => element.remove());
    }
  } else {
    if (fbtMobileOnly.length) {
      fbtMobileOnly.forEach(element => element.remove());
    }
  }

  // Array to hold the selected variant IDs
  let selectedVariantIds = [];

  // Update the total price display
  function updateTotal() {
    const total = calculateCheckedFbtTotal();

    fbtTotalEls.forEach(el => {

      el.innerHTML = '$' + (total / 100).toFixed(2);
    });
  }

  // Calculate total from checked checkboxes using their data-price values
  function calculateCheckedFbtTotal() {
    let total = 0;
    checkboxes.forEach(box => {
      if (box.checked) {
        total += Number(box.dataset.price);
      }
    });
    return total;
  }

  // Manage the visibility of images and update the selected variant IDs
  function manageFBT(isChecked, variantId) {
    fbtImgContainers.forEach((item, index) => {
      if (item.dataset.variantid === variantId) {
        if (isChecked) {
          item.style.display = 'block';
          if (!selectedVariantIds.includes(variantId)) {
            selectedVariantIds.push(variantId);
          }
          handlePlus(index, 'add');
        } else {
          item.style.display = 'none';
          selectedVariantIds = selectedVariantIds.filter(id => id !== variantId);
          handlePlus(index, 'remove');
        }
      }
    });
    updateTotal();
  }

  // Toggle plus indicator visibility based on the number of selected variants
  function handlePlus(index, type) {
    if (selectedVariantIds.length < 2) {
      if (plusTwo) plusTwo.style.display = 'none';
    } else {
      if (plusTwo) plusTwo.style.display = 'block';
    }
  }

  // Set up checkbox event listeners
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', event => {
      manageFBT(event.target.checked, event.target.dataset.variantid);
    });
  });

  // Initialize in case some checkboxes are pre-checked
  checkboxes.forEach(checkbox => {
    manageFBT(checkbox.checked, checkbox.dataset.variantid);
  });

  // Set up Add-to-Cart button listeners
  if (fbtAtcButtons.length) {
    fbtAtcButtons.forEach(button => {
      button.addEventListener('click', async () => {
        let addToCartResponse = await addToCart(selectedVariantIds, 1);

        if (addToCartResponse.status) {
          theme.miniCart.generateCart();
          theme.miniCart.updateElements();
        }
      });
    });
  }

  // Initial total update
  updateTotal();
}

/**
 * Attaches click handlers to "May Also Like" size buttons that clone and display the hidden sizes container,
 * while preventing default actions and hiding the original element.
 */
function handleMayLikeSizesButtons(mayLikeSizesButtons) {
  mayLikeSizesButtons.forEach(mayLikeSizesButton => {
    mayLikeSizesButton.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const containerToShowSizes = mayLikeSizesButton.closest('.may-also-like-products-container').querySelector('.sizes-container-fixed');
      const sizesContainer = mayLikeSizesButton.closest('.custom-collection-grid__item-link').querySelector('.product-in-collection__sizes');

      if (containerToShowSizes && sizesContainer) {
        containerToShowSizes.classList.remove('product-hidden');
        containerToShowSizes.innerHTML = "";
        sizesContainer.removeAttribute('style');
        containerToShowSizes.appendChild(sizesContainer.cloneNode(true));
        sizesContainer.setAttribute('style', 'display: none !important;');
      }
    });
  });
}

/**
 * Navigates the given productThumbnailsSwiper to the slide marked as active (using its data-swiper-slide-index).
 * If no active slide or valid index is found, it does nothing.
 */
function goToActiveThumbnailSlide(productThumbnailsSwiper) {
  const activeSlide = document.querySelector(
    '.main-product-container__image--thumbs .product-single__thumbnail-item.is-active'
  );

  if (activeSlide) {
    productThumbnailsSwiper.update();
    productThumbnailsSwiper.updateSize();

    const indexPosition = parseInt(activeSlide.getAttribute('aria-label').split('/')[0], 10) - 1;
    if (!isNaN(indexPosition)) {
      productThumbnailsSwiper.slideTo(indexPosition, 300);
    }
  }
}
